import createLucideIcon from '../createLucideIcon';

/**
 * @component @name SolarPanel
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgMmgyIiAvPgogIDxwYXRoIGQ9Im0xNC4yOCAxNC00LjU2IDgiIC8+CiAgPHBhdGggZD0ibTIxIDIyLTEuNTU4LTRINC41NTgiIC8+CiAgPHBhdGggZD0iTTMgMTB2MiIgLz4KICA8cGF0aCBkPSJNNi4yNDUgMTUuMDRBMiAyIDAgMCAxIDggMTRoMTJhMSAxIDAgMCAxIC44NjQgMS41MDVsLTMuMTEgNS40NTdBMiAyIDAgMCAxIDE2IDIySDRhMSAxIDAgMCAxLS44NjMtMS41MDZ6IiAvPgogIDxwYXRoIGQ9Ik03IDJhNCA0IDAgMCAxLTQgNCIgLz4KICA8cGF0aCBkPSJtOC42NiA3LjY2IDEuNDEgMS40MSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/solar-panel
 * @see https://lucide.dev/guide/packages/lucide-preact - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SolarPanel = createLucideIcon('solar-panel', [
  ['path', { d: 'M11 2h2', key: 'isr7bz' }],
  ['path', { d: 'm14.28 14-4.56 8', key: '4anwcf' }],
  ['path', { d: 'm21 22-1.558-4H4.558', key: 'enk13h' }],
  ['path', { d: 'M3 10v2', key: 'w8mti9' }],
  [
    'path',
    {
      d: 'M6.245 15.04A2 2 0 0 1 8 14h12a1 1 0 0 1 .864 1.505l-3.11 5.457A2 2 0 0 1 16 22H4a1 1 0 0 1-.863-1.506z',
      key: 'pouggg',
    },
  ],
  ['path', { d: 'M7 2a4 4 0 0 1-4 4', key: '78s8of' }],
  ['path', { d: 'm8.66 7.66 1.41 1.41', key: '1vaqj8' }],
]);

export default SolarPanel;
